/* eslint-disable no-unused-vars */
import CardTableNeraca from "components/Cards/CardTableNeraca";
import React, { useState, useEffect } from "react";
import toast, { Toaster } from "react-hot-toast";
import { getLaporanNeraca } from "./api/neracaAPI";

export default function Neraca() {
  const [dataAktivaLancar, setDataAktivaLancar] = useState([]);
  const [dataAktivaTetap, setDataAktivaTetap] = useState([]);
  const [dataKewajibanJangkaPanjang, setDataKewajibanJangkaPanjang] = useState(
    []
  );
  const [dataKewajibanJangkaPendek, setDataKewajibanJangkaPendek] = useState(
    []
  );
  const [dataModal, setDataModal] = useState([]);
  const [totalAktivaLancar, setTotalAktivaLancar] = useState(0);
  const [totalAktivaTetap, setTotalAktivaTetap] = useState(0);
  const [totalAktiva, setTotalAktiva] = useState(0);
  const [totalKewajibanJangkaPendek, setTotalKewajibanJangkaPendek] =
    useState(0);
  const [totalKewajibanJangkaPanjang, setTotalKewajibanJangkaPanjang] =
    useState(0);
  const [totalKewajiban, setTotalKewajiban] = useState(0);
  const [totalModal, setTotalModal] = useState(0);

  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [errors, setErrors] = useState(null);

  //Loading
  useEffect(() => {
    if (isLoading === true) {
      toast.loading("Data Diproses...");
    } else {
      toast.dismiss();
    }

    return () => {
      setIsLoading(false);
    };
  }, [isLoading]);

  // Check if Request Failed
  useEffect(() => {
    if (errors !== null) {
      toast.error(errors.message);
    }
  }, [errors]);

  useEffect(() => {
    getLaporanNeraca()
      .then((res) => {
        setResult(res.data.data);
      })
      .catch((err) => {
        setErrors(err);
      })
      .finally(() => {
        setTimeout(() => {}, 5000);
        toast.dismiss();
      });
  }, []);

  useEffect(() => {
    if (result !== null) {
      setDataAktivaLancar(result.dataAktivaLancar);
      setDataAktivaTetap(result.dataAktivaTetap);
      setDataKewajibanJangkaPendek(result.dataKewajibanJangkaPendek);
      setDataKewajibanJangkaPanjang(result.dataKewajibanJangkaPanjang);
      setDataModal(result.dataModal);
      setTotalAktivaLancar(result.totalAktivaLancar);
      setTotalAktivaTetap(result.totalAktivaTetap);
      setTotalAktiva(result.totalAktiva);
      setTotalKewajibanJangkaPendek(result.totalKewajibanJangkaPendek);
      setTotalKewajibanJangkaPanjang(result.totalKewajibanJangkaPanjang);
      setTotalKewajiban(result.totalKewajiban);
      setTotalModal(result.totalModal);
    }
  }, [result]);

  return (
    <div>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          <Toaster />
          <CardTableNeraca
            tableTitle="Laporan Neraca"
            dataAktivaLancar={dataAktivaLancar}
            dataAktivaTetap={dataAktivaTetap}
            dataKewajibanJangkaPendek={dataKewajibanJangkaPendek}
            dataKewajibanJangkaPanjang={dataKewajibanJangkaPanjang}
            dataModal={dataModal}
            totalAktivaLancar={totalAktivaLancar}
            totalAktivaTetap={totalAktivaTetap}
            totalAktiva={totalAktiva}
            totalKewajibanJangkaPendek={totalKewajibanJangkaPendek}
            totalKewajibanJangkaPanjang={totalKewajibanJangkaPanjang}
            totalKewajiban={totalKewajiban}
            totalModal={totalModal}
          />
        </div>
      </div>
    </div>
  );
}
